<template>
  <component
    :is="locked ? PhLockSimple : PhDotsSixVertical"
    class="drag-handle"
    :class="{ 'drag-handle--locked': locked }"
    :size="locked ? 16 : 24"
  />
</template>

<script lang="ts" setup>
import { PhDotsSixVertical, PhLockSimple } from '@phosphor-icons/vue'

defineProps<{
  locked?: boolean
}>()
</script>

<style lang="scss">
.drag-handle {
  cursor: grab;
  flex-shrink: 0;

  &--locked {
    cursor: not-allowed;
    margin: 4px;
  }
}
</style>
